import { render, staticRenderFns } from "./FormaDataDetails.vue?vue&type=template&id=56799c2f&scoped=true&"
import script from "./FormaDataDetails.vue?vue&type=script&lang=js&"
export * from "./FormaDataDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56799c2f",
  null
  
)

export default component.exports